export default __webpack_public_path__ + "static/media/pe.b62f3cf8.svg";